import * as Yup from "yup";

export default () => {
  return Yup.object().shape({
    feeTypeName: Yup.string().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_GIVE_VALID_RECORD"
    ),
    description: Yup.string().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_GIVE_VALID_RECORD"
    ),
    fromDate: Yup.date()
      .transform((value, originalValue) => {
        return originalValue === "" ? null : value;
      })
      .nullable()
      .typeError("US.COLLECTION.VALIDATIONS:REQUIRED.INVALID_DATE")
      .required("US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_GIVE_VALID_RECORD"),
    debtorType: Yup.string().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_GIVE_VALID_RECORD"
    ),
  });
};
